(function () {
  'use strict';

  if (window.__hjLandingInit) return;
  window.__hjLandingInit = true;

  function initCopyButtons() {
    var buttons = document.querySelectorAll('[data-hj-copy]');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var code = button.getAttribute('data-hj-copy');
        var label = button.getAttribute('data-hj-copy-label') || button.textContent.trim();
        var doneLabel = button.getAttribute('data-hj-copied-label') || 'Copied!';

        function showCopied() {
          button.setAttribute('data-copied', 'true');
          var labelEl = button.querySelector('[data-hj-copy-text]');
          if (labelEl) {
            labelEl.textContent = doneLabel;
          }
          window.clearTimeout(button._hjCopyTimeout);
          button._hjCopyTimeout = window.setTimeout(function () {
            button.removeAttribute('data-copied');
            if (labelEl) {
              labelEl.textContent = label;
            }
          }, 2000);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(showCopied, showCopied);
        } else {
          var input = document.createElement('input');
          input.value = code;
          input.setAttribute('readonly', '');
          input.style.position = 'absolute';
          input.style.left = '-9999px';
          document.body.appendChild(input);
          input.select();
          try {
            document.execCommand('copy');
          } catch (err) {
            /* no-op */
          }
          document.body.removeChild(input);
          showCopied();
        }
      });
    });
  }

  function initStickyBar() {
    var bar = document.querySelector('[data-hj-sticky-bar]');
    if (!bar) return;

    var hero = document.querySelector('[data-hj-hero]');
    var footer = document.querySelector('.footer, #footer, [data-footer]') || document.querySelector('footer');
    var ticking = false;

    function update() {
      ticking = false;

      var pastHero = hero
        ? window.scrollY > hero.offsetTop + hero.offsetHeight - 80
        : window.scrollY > window.innerHeight * 0.5;

      var nearBottom = false;
      if (footer) {
        var footerRect = footer.getBoundingClientRect();
        nearBottom = footerRect.top < window.innerHeight;
      }

      var shouldShow = pastHero && !nearBottom;
      bar.classList.toggle('hj-is-visible', shouldShow);
      document.body.classList.toggle('hj-has-sticky-bar', shouldShow);
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function initQuoteFormScroll() {
    var form = document.querySelector('[data-hj-quote-form]');
    if (!form) return;

    var status = form.querySelector('.alert-message');
    if (status) {
      window.setTimeout(function () {
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  function ready() {
    initCopyButtons();
    initStickyBar();
    initQuoteFormScroll();
  }
})();
